import type { UIKitIndentationsProps } from "@qws-org/ui-kit";
import { Image } from "@qws-org/ui-kit";
import type { FC } from "react";

import type { HeaderData } from "~/features/headerV4/HeaderV4";
import { useDirectus } from "~/shared/utils/directus/useDirectus";

type HeaderLogoProps = {
  data: HeaderData;
} & Partial<UIKitIndentationsProps> & {
    md?: Partial<UIKitIndentationsProps>;
    d?: Partial<UIKitIndentationsProps>;
  };
export const HeaderLogo: FC<HeaderLogoProps> = ({ data, md, d, ...rest }) => {
  const { getDirectusImage } = useDirectus();
  return (
    <Image
      display="block"
      maxWidth={85}
      value={getDirectusImage(data?.header_logo?.id ?? "", {
        format: "svg",
        width: 85,
      })}
      mdValue={getDirectusImage(data?.header_logo?.id ?? "", {
        format: "svg",
        width: 170,
      })}
      image={{ width: 189, height: 47 }}
      {...rest}
      md={{ maxWidth: 170, ...md }}
      d={{ ...d }}
    />
  );
};
